<nz-spin [nzSpinning]="loading$ | async">
  <div class="drawer-form-wrapper without-bottom-cta">
    <app-enter-data-heading
      [selectedUnit]="drawerParams.selectedUnit"></app-enter-data-heading>
    <div class="header-with-cta mb-24 rang-picker-container">
      <div class="cta-wrapper">
        <h4 class="text s-16">Timeline</h4>
        <nz-range-picker
          [nzAllowClear]="false"
          [nzDisabledDate]="disableFutureDates"
          [(ngModel)]="weekRange"
          (ngModelChange)="onWeekRangeChange($event)"
          nzFormat="MM/dd/yyyy"
          nzSeparator="to"
          nzShowTime="false"
          [nzPlaceHolder]="[
            'Start (Sunday)',
            'End (Saturday)',
          ]"></nz-range-picker>
      </div>
      <div *ngIf="rangeErrorMsg" class="error-text mt-2">
        {{ rangeErrorMsg }}
      </div>
    </div>
    <nz-table
      class="mb-24"
      #basicTable
      [nzData]="dataSheetDataItems"
      [nzShowPagination]="false"
      [nzFrontPagination]="false"
      [nzScroll]="{ x: 'max-content', y: 'calc(100vh - 290px)' }">
      <thead>
        <tr>
          <th scope="col" nzWidth="85px">
            <div class="table-header-wrap">Day</div>
          </th>
          <th scope="col" nzWidth="110px">
            <div class="table-header-wrap">Date</div>
          </th>
          <th scope="col" nzWidth="110px">
            <div class="table-header-wrap">Individual Interval Details</div>
          </th>
          <th
            scope="col"
            nzWidth="80px"
            *ngIf="drawerParams.selectedUnit !== 3">
            <div class="table-header-wrap">Total Frequency</div>
          </th>
          <th
            scope="col"
            nzWidth="100px"
            *ngIf="
              drawerParams.selectedUnit === 1 || drawerParams.selectedUnit === 2
            ">
            <div class="table-header-wrap">
              Total
              {{ drawerParams.selectedUnit === 2 ? 'Latency' : 'Duration' }}
            </div>
          </th>
          <th
            scope="col"
            nzWidth="90px"
            *ngIf="
              drawerParams.selectedUnit === 1 || drawerParams.selectedUnit === 2
            ">
            <div class="table-header-wrap">
              Average
              {{ drawerParams.selectedUnit === 2 ? 'Latency' : 'Duration' }}
            </div>
          </th>
          <th
            scope="col"
            nzWidth="100px"
            *ngIf="drawerParams.selectedUnit === 3">
            <div class="table-header-wrap">Partial Interval Average</div>
          </th>
          <th
            scope="col"
            *ngIf="drawerParams.selectedUnit === 1"
            nzWidth="370px"></th>
          <th
            scope="col"
            *ngIf="drawerParams.selectedUnit !== 1"
            nzWidth="150px"></th>
          <th scope="col" nzWidth="160px"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of filteredDataSheetDataItems">
          <td [title]="data.day">{{ data.day }}</td>
          <td [title]="data.date | date: 'MM/dd/yyyy'">
            {{ data.date | date: 'MM/dd/yyyy' }}
          </td>
          <td [title]="data.individualIntervalDetails">
            {{ data.individualIntervalDetails }}
          </td>
          <td *ngIf="drawerParams.selectedUnit !== 3">
            <span *ngIf="data.totalFrequency && !isModify"
              >{{ data.totalFrequency }}
            </span>
            <input
              *ngIf="isModify && !isFutureDate(data.date) && !data.isDuration"
              name="from"
              type="text"
              [(ngModel)]="data.totalFrequency"
              nz-input
              [mask]="'000'"
              [validation]="false"
              appAllowOnlyValidNumbers
              placeholder="Total Frequency"
              (ngModelChange)="data.isUpdateTotal = true" />
          </td>
          <td
            [title]="data.totalDuration"
            *ngIf="
              drawerParams.selectedUnit === 1 || drawerParams.selectedUnit === 2
            ">
            {{
              !isFutureDate(data.date)
                ? data.isDuration
                  ? data.totalDuration
                  : ''
                : ''
            }}
          </td>
          <td
            *ngIf="
              drawerParams.selectedUnit === 1 || drawerParams.selectedUnit === 2
            "
            [title]="data.averageDuration">
            {{ data.averageDuration }}
          </td>
          <td *ngIf="drawerParams.selectedUnit === 3">
            {{ getAvgPartialInterval(data.individualIntervalDetails) }}
          </td>
          <td *ngIf="drawerParams.selectedUnit === 1">
            <div
              class="action-btn-wrapper"
              *ngIf="drawerParams.selectedUnit === 1">
              <button
                nz-button
                nzType="default"
                *ngIf="!isFutureDate(data.date)"
                [disabled]="data.isDuration"
                (click)="openSetFrequencyDrawer(data)">
                Set Frequency
              </button>
              <button
                nz-button
                nzType="default"
                [disabled]="data.isFrequencyValue"
                *ngIf="!isFutureDate(data.date)"
                (click)="openSetDurationDrawer(data)">
                Set Duration
              </button>
            </div>
          </td>
          <td *ngIf="drawerParams.selectedUnit !== 1">
            <div
              class="action-btn-wrapper"
              *ngIf="
                drawerParams.selectedUnit !== 1 && !isFutureDate(data.date)
              ">
              <button nz-button nzType="default" (click)="openDataDrawer(data)">
                Enter Data
              </button>
            </div>
          </td>
          <td>
            <div class="action-btn-wrapper">
              <button
                *ngIf="data.commentCount === 0 && !isFutureDate(data.date)"
                nz-button
                nzType="text"
                class="primary-text-btn"
                (click)="openDataNotesDrawer(data)">
                Add Notes
              </button>
              <button
                *ngIf="data.commentCount > 0 && !isFutureDate(data.date)"
                nz-button
                nzType="text"
                class="primary-text-btn"
                (click)="openDataNotesDrawer(data)">
                View Notes
              </button>
              <button
                nz-button
                nzType="text"
                class="primary-text-btn"
                (click)="delete(data)"
                [disabled]="!data.isDuration && !data.isFrequencyValue"
                *ngIf="!isFutureDate(data.date)">
                Delete
              </button>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="drawerParams.selectedUnit !== 3">
        <tr>
          <td></td>
          <td>
            <span *ngIf="drawerParams.selectedUnit !== 3">Total</span>
          </td>
          <td></td>
          <td *ngIf="drawerParams.selectedUnit !== 3">
            {{ getGrandTotal }}
          </td>
          <td
            *ngIf="
              drawerParams.selectedUnit === 1 || drawerParams.selectedUnit === 2
            ">
            {{ getTotalOfDuration }}
          </td>
          <td
            *ngIf="
              drawerParams.selectedUnit === 1 || drawerParams.selectedUnit === 2
            ">
            {{ getTotalforAverage }}
          </td>
          <td></td>
          <td></td>
        </tr>
      </tfoot>
    </nz-table>
    <div class="display-flex justify-content-between mt-3">
      <div></div>
      <div class="button-container">
        <button
          nz-button
          nzType="default"
          (click)="prevWeek()"
          [disabled]="isModify">
          Previous
        </button>
        <button
          nz-button
          nzType="primary"
          (click)="nextWeek()"
          [disabled]="isCurrentWeek() || isModify">
          Next
        </button>
        <ng-container *ngIf="isModify">
          <button
            nz-button
            nzType="text"
            class="primary-text-btn"
            (click)="applyModify(); $event.stopPropagation()">
            Apply
          </button>
          <button
            nz-button
            nzType="text"
            (click)="cancelModify(); $event.stopPropagation()">
            Cancel
          </button>
        </ng-container>
        <button
          *ngIf="
            (!isModify && drawerParams.selectedUnit === 1) ||
            drawerParams.selectedUnit === 4
          "
          nz-button
          nzType="text"
          class="primary-text-btn"
          (click)="modify()">
          Modify
        </button>
      </div>
    </div>
  </div>
  <app-confirm-dialog
    [isVisible]="showConfirmDialog"
    [title]="'Delete Record'"
    [message]="deleteMsg"
    [iconSrc]="'/assets/icon/icon-trash-red.svg'"
    [iconColor]="'red'"
    [cancelText]="'Cancel'"
    [confirmText]="'Delete'"
    [loading]="isDeleting"
    (confirmed)="removeUnitValue()"
    (cancelled)="handleCancel()"
    (closed)="handleCancel()">
  </app-confirm-dialog>

  <ng-template #drawerTitleFrequency>
    <app-drawer-header
      [title]="'Data'"
      [subtitle]="''"
      [breadcrumbText]="''"
      (drawerClose)="closeFrequencyDrawer()">
    </app-drawer-header>
  </ng-template>

  <ng-template #drawerTitleDuration>
    <app-drawer-header
      [title]="'Data'"
      [subtitle]="''"
      [breadcrumbText]="''"
      (drawerClose)="closeDurationDrawer()">
    </app-drawer-header>
  </ng-template>

  <ng-template #drawerTitlePartialInterval>
    <app-drawer-header
      [title]="'Data'"
      [subtitle]="''"
      [breadcrumbText]="''"
      (drawerClose)="closePartialIntervalDrawer()">
    </app-drawer-header>
  </ng-template>

  <ng-template #drawerTitleDataNotes>
    <app-drawer-header
      [title]="'Notes'"
      [subtitle]="''"
      [breadcrumbText]="''"
      (drawerClose)="closeDataNotesDrawer()">
    </app-drawer-header>
  </ng-template>
</nz-spin>
